import {
    CLOSE_FILTERS,
    FINISH_UPDATE_FILTERS,
    OPEN_FILTERS,
    START_UPDATE_FILTERS,
    UPDATE_SEARCH_OPTIONS,
    UPDATE_SEARCH_PARAMETERS,
    UPDATE_SEARCH_TAGS
} from "./actions";
import {Search} from "./types";

const initialState: Search = {
    showFilters: false,
    shownFilters: [],
    searchParameters: null,
    searchOptions: null,
    waitingForUpdate: false,
    allTags: null,
};

export function searchReducer(
    state = initialState,
    action: any,
): Search {
    switch (action.type) {
        case UPDATE_SEARCH_PARAMETERS: {
            const newSearchParameters = {...state.searchParameters, ...action.payload.params};

            return {
                ...state,
                searchParameters: newSearchParameters,
            };
        }
        case UPDATE_SEARCH_OPTIONS: {
            const newSearchOptions = {...state.searchOptions, ...action.payload.options};
            return {
                ...state,
                searchOptions: newSearchOptions,
            };
        }
        case UPDATE_SEARCH_TAGS: {
            return {
                ...state,
                allTags: action.payload.tags,
            };
        }
        case OPEN_FILTERS: {
            const filter = action.payload.filter;
            let filters;

            if (state.shownFilters.includes(filter)) {
                filters = state.shownFilters.filter(item => item !== filter);
            } else {
                filters = [...state.shownFilters, filter];
            }

            return {
                ...state,
                showFilters: true,
                shownFilters: filters,
            };
        }
        case CLOSE_FILTERS: {
            return {
                ...state,
                showFilters: false,
                shownFilters: [],
            };
        }
        case START_UPDATE_FILTERS: {
            return {
                ...state,
                waitingForUpdate: true,
            };
        }
        case FINISH_UPDATE_FILTERS: {
            return {
                ...state,
                waitingForUpdate: false,
            };
        }
        default:
            return state
    }
}
